<eui-sidebar-toggle *ngIf="(asService.state$ | async).hasSidebar && (asService.state$ | async).hasHeader && !(asService.state$ | async).hasToolbar"
                    styleClass="eui-app-header__sidebar-toggle">
</eui-sidebar-toggle>

<ng-content select="eui-header"></ng-content>
